export const useFeedbackStore = defineStore({
  id: 'feedback',
  actions: {
    sendFeedback(fields) {
      return useRequest('/feedback', {
        method: 'post',
        body: {
          name: fields.name,
          email: fields.email,
          message: fields.message,
        },
      }).catch((error) => {
        const {
          data: { errors },
        } = error;

        if (!errors) throw error;

        throw {
          errors: {
            name: errors.name,
            email: errors.email,
            message: errors.message,
          },
        };
      });
    },
  },
});
